export default "__VITE_ASSET__CiTtX94Z__"